module.exports = __webpack_public_path__ + "media/assets/images/SYB_FDay2022_Menu_Banner_A-f091fe9a6bea8de3c73b6d2302feda98.jpg";